import { defineStore } from 'pinia'
import remindersApi from '@/api/remindersApi.js'

// Глобальный callback для toast (устанавливается из App.vue)
let toastCallback = null

export function setReminderToastCallback(callback) {
  toastCallback = callback
}

export const useRemindersStore = defineStore('remindersStore', {
    state: () => ({
        items: [],
        loading: false,
        error: null,
        page: 1,
        count: 0,
        next: null,
        prev: null,
        shownToasts: new Set(), // Для отслеживания уже показанных toast
    }),
    getters: {
        // Внимание: поле acknowledged может не приходить в ReminderList — используйте только если бек его добавляет
        unread: (s) => s.items.filter(r => r.status === 'SENT' && !r.acknowledged),
    },
    actions: {
        async load({ acknowledged, status = 'SENT', page = 1 } = {}) {
            this.loading = true
            this.error = null
            try {
                const params = { status, page }
                if (acknowledged !== undefined) params.acknowledged = acknowledged
                const data = await remindersApi.list(params)
                const results = Array.isArray(data?.results) ? data.results : []
                this.items = results
                this.count = data?.count ?? results.length
                this.next = data?.next ?? null
                this.prev = data?.previous ?? null
                this.page = page
            } catch (e) {
                this.error = e
                this.items = []
            } finally {
                this.loading = false
            }
        },

        async create(payload) {
            const created = await remindersApi.create(payload)
            this.items = [created, ...this.items]
            return created
        },

        async get(id) {
            return remindersApi.get(id)
        },

        async acknowledge(id) {
            await remindersApi.acknowledge(id)
            this.items = this.items.map(r => r.id === id ? { ...r, acknowledged: true } : r)
        },

        async cancel(id) {
            await remindersApi.cancel(id)
            this.items = this.items.filter(r => r.id !== id)
        },

        // WebSocket event handlers
        applyWsEvent(payload) {
            if (payload?.type === 'reminder' && payload?.event === 'fired') {
                const reminder = payload.reminder || payload
                this.handleReminderFired(reminder)
            }
        },

        handleReminderFired(reminder) {
            if (!reminder) return

            const id = reminder.source_id ?? reminder.id
            if (!id || this.shownToasts.has(id)) {
                // Уже показывали это напоминание
                return
            }

            // Помечаем как показанное
            this.shownToasts.add(id)

            // Показываем toast только один раз
            if (toastCallback) {
                toastCallback(reminder)
            }
        },
    }
})